import React from "react";
import { StoryElement, Link } from "@quintype/components";
import get from "lodash/get";
import { DefaultStoryCard } from "../../DefaultStoryCard";
import { getLinksFromString, isNonEmptyNode, isTemplateWithAds } from "../../../utils/story";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { WithStoryAds } from "../../WithStoryAds";
import "./free-author-box.m.css";

function getBaseDomain(url) {
  const parsedUrl = new URL(url);
  const hostnameParts = parsedUrl.hostname.split(".");

  if (hostnameParts.length > 2) {
    return hostnameParts.slice(-2).join(".");
  }
  return parsedUrl.hostname;
}

const domains = ["facebook", "linkedin", "whatsapp", "twitter", "x", "instagram", "youtube"];

const SocialLinks = (socialLinks) => {
  return (
    <div styleName="social-icons">
      {socialLinks.links.map((item) => {
        const host = getBaseDomain(item);
        const domainName = host.replaceAll(".com", "");
        const isIconPresent = domains.includes(domainName);
        return isIconPresent ? (
          <Link key={item} href={item} target="_blank">
            <SvgIconHandler
              type={domainName === "twitter" ? "x" : domainName}
              width="44"
              height="44"
              iconStyle={{ color: "#596E79" }}
            />
          </Link>
        ) : (
          <></>
        );
      })}
    </div>
  );
};

export default function FreeAuthorBox({ story, card, counter = {} }) {
  const customStoryElements = card["story-elements"];
  const isFreeAuthorBox = get(card, ["metadata", "attributes", "cardtype", "0"], null) === "Free_Author_Box";
  const authorboxEle = {};
  const enableParagraphAds = !isFreeAuthorBox && isTemplateWithAds(story);

  customStoryElements.map((element) => {
    if (element.type === "image") {
      authorboxEle.image = element;
      authorboxEle.caption = isNonEmptyNode(element?.title);
      getLinksFromString(element?.["image-attribution"])?.length > 0
        ? (authorboxEle.links = getLinksFromString(element?.["image-attribution"]))
        : (authorboxEle.imageAttr = isNonEmptyNode(element?.["image-attribution"]));
    }
    if (element.type === "text") {
      authorboxEle.details = isNonEmptyNode(element?.text);
    }
  });

  const showDefault = !authorboxEle?.image || !authorboxEle?.details;
  const componentToRender = (
    <div className="story-element story-element-author-box" styleName="free-author-box-wrapper">
      <div styleName="author-box">
        <div styleName="author-image">
          <StoryElement element={authorboxEle?.image} story={story} loadIframeOnClick />
        </div>
        {authorboxEle?.links ? (
          <div styleName="author-details-links">
            {authorboxEle?.caption && (
              <div styleName="caption" dangerouslySetInnerHTML={{ __html: authorboxEle?.caption }} />
            )}
            <SocialLinks links={authorboxEle.links} />
          </div>
        ) : (
          <div styleName="author-details">
            {authorboxEle?.caption && (
              <div styleName="caption" dangerouslySetInnerHTML={{ __html: authorboxEle?.caption }} />
            )}
            {authorboxEle?.imageAttr && (
              <div styleName="attr" dangerouslySetInnerHTML={{ __html: authorboxEle?.imageAttr }} />
            )}
          </div>
        )}
      </div>
      <div styleName="author-info">
        {authorboxEle?.details && <div dangerouslySetInnerHTML={{ __html: authorboxEle.details }} />}
      </div>
    </div>
  );

  if (showDefault) {
    return <DefaultStoryCard card={card} story={story} counter={counter} />;
  }

  return enableParagraphAds ? (
    <WithStoryAds counter={counter} componentToRender={componentToRender} story={story} />
  ) : (
    <>{componentToRender}</>
  );
}
